import { render, staticRenderFns } from "./BadAddressesReport.vue?vue&type=template&id=8f6832ec&"
import script from "./BadAddressesReport.vue?vue&type=script&lang=js&"
export * from "./BadAddressesReport.vue?vue&type=script&lang=js&"
import style0 from "./BadAddressesReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports